import { PropsWithChildren } from 'react';

import { QueryParamProvider as QueryParamProviderOriginal } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

/**
 * QueryParamProvider
 * @param root0 Пропсы
 * @param root0.children Дочерние элементы
 */
const QueryParam = ({ children }: PropsWithChildren) => (
  <QueryParamProviderOriginal adapter={ReactRouter6Adapter}>
    {children}
  </QueryParamProviderOriginal>
);

export default QueryParam;
